import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const ComparisonScreenSlideshow = ({
  key,
  heading=null,
  content=null,
  comparisonSlides=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
      <div className="comparison-screen-slideshow">
        <div className="container">
          <div className="d-flex jcc">
            <div className="col-12 col-lg-10 col-xl-7">
              {heading &&
              <h2 className={ `content-title center ${content ? "orange-dash" : ""}` }>{ htmlDecode(heading) }</h2>
              }
              <span className="orange-line-after" />
              {content &&
              <div className="comparison-content" dangerouslySetInnerHTML={{ __html: content }} />
              }
            </div>
          </div>
          <div className="col-12 col-md-10 offset-md-1 col-lg-12 offset-lg-0 comparison-slideshow">

            {comparisonSlides &&
            <div className="d-flex">
              <div
                  id="comparisonScreenSlideshow"
                  className="comparisonScreenSlideshow carousel slide flex-lg-row flex-lg-nowrap"
                  data-ride="carousel"
              >
                <ol className="col-12 col-lg-5">
                  <div className="carousel-indicators">
                    {comparisonSlides.map((slide, index) => (
                        <li data-target="#comparisonScreenSlideshow" data-slide-to={ index } className={ `${!index ? "active" : ""}` }>
                          {slide.title &&
                          <h3 className="slide-title d-none d-lg-block">{ htmlDecode(slide.title) }</h3>
                          }
                          {slide.content &&
                          <div className="slide-content section-content smaller d-none d-lg-block" dangerouslySetInnerHTML={{ __html: slide.content }} />
                          }
                        </li>
                    ))}
                  </div>
                </ol>
                <div className="col-12 col-lg-7">
                  <div className="carousel-inner">
                    {comparisonSlides.map((slide, index) => (
                        <div className={ `carousel-item ${!index ? "active" : ""}` }>
                          {slide.image &&
                          <>
                            {slide.image &&
                            <img src={slide.image.url.includes(cdnUrl) ? slide.image.url : cdnUrl + slide.image.url} alt={ htmlDecode(slide.title) } />
                            }
                            {slide.title &&
                            <h3 className="slide-title d-lg-none">{ htmlDecode(slide.title) }</h3>
                            }
                            {slide.content &&
                            <div className="slide-content d-lg-none" dangerouslySetInnerHTML={{ __html: slide.content }} />
                            }
                          </>
                          }
                        </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            }

          </div>
        </div>
      </div>
  )
}

export default ComparisonScreenSlideshow
